export class DotAssetColors {
  static BLUE = '#0018F9';
  static YELLOW = '#FFCB02';
}